// extracted by mini-css-extract-plugin
export default {"container":"style_container__wgJ2I","icon":"style_icon__e4Ub-","text":"style_text__qoX0N"};